import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';

import { memoize } from 'lodash';

import PlanningList from './PlanningList';
import { Skeleton } from '@material-ui/lab';

class PlanningLists extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        filter: PropTypes.string,
        applications: PropTypes.array,
        PlanningCardProps: PropTypes.object
    };

    static defaultProps = {
        PlanningCardProps: {}
    };

    constructor (props) {
        super(props);
        this.state = {
            isExpanded: props.isExpandedDefault
        };

        this.handleToggleExpand = this.handleToggleExpand.bind(this);
        this.filterByDate = this.filterByDate.bind(this);
    }

    handleToggleExpand () {
        this.setState({
            isExpanded: !this.state.isExpanded
        });
    }

    filterByDate (app, startMonths, endMonths) {
        const startDate = new Date(app.startDate);
        const now = new Date(Date.now());
        const sDate = new Date(now).setMonth(now.getMonth() - startMonths);
        const eDate = endMonths && new Date(now).setMonth(now.getMonth() - endMonths);
        return startDate < sDate && (!endMonths || startDate > eDate);
    }

    getMemoizedApplications = memoize(
        (apps, startMonths, endMonths) => apps.filter(e => this.filterByDate(e, startMonths, endMonths)),
        (...args) => `${args[0].reduce((acc, cur) => acc + cur.name, '')}_${args[1]}_${args[2]}`
    );

    render () {
        const { classes, applications, filter, PlanningCardProps } = this.props;

        const isLoading = !Boolean(applications);

        if (isLoading) { return <Skeleton animation="wave" height={75} variant="rect" />; }

        const start = 6; // For testing, this needs to change to 6
        const end = 12; // For testing, this needs to change to 12

        const filteredApps = filter ? applications.filter(e => e.appStateAggregateV2 === filter) : applications;
        const newestApps = this.getMemoizedApplications(filteredApps, 0, start);
        const recentApps = this.getMemoizedApplications(filteredApps, start, end);
        const oldestApps = this.getMemoizedApplications(filteredApps, end, null);

        return (
            <>
                { newestApps.length > 0 && <PlanningList
                    label={`LAST ${start} MONTHS`}
                    applications={newestApps}
                    isExpandedDefault
                    PlanningCardProps={PlanningCardProps}
                /> }
                { recentApps.length > 0 && <PlanningList
                    label={`LAST ${end} MONTHS`}
                    applications={recentApps}
                    isExpandedDefault={newestApps.length === 0}
                    PlanningCardProps={PlanningCardProps}
                /> }
                { oldestApps.length > 0 && <PlanningList
                    label={`OLDER THAN ${end} MONTHS`}
                    applications={oldestApps}
                    isExpandedDefault={newestApps.length === 0 && oldestApps.length === 0}
                    PlanningCardProps={PlanningCardProps}
                /> }
            </>
        );
    }
}

const style = theme => ({

});

export default withStyles(style)(PlanningLists);